import Dexie, { type EntityTable } from "dexie";

import { CommercetoolsProject, LocationDB, MapPinDB, SettingsDB } from "@/types";

const version = 94;
Dexie.debug = "dexie";

export const DB_NAME = `dpcatalog-${version}`;
export const LOCATIONS = "locations";
export const PINS = "pins";
export const PROJECTS = "projects";
export const PROPERTY_TYPE = "propertyType";
export const SETTINGS = "settings";

export const db = new Dexie(DB_NAME) as Dexie & {
  LOCATIONS: EntityTable<LocationDB, "id">;
  PROJECTS: EntityTable<CommercetoolsProject, "id">;
  PROPERTY_TYPE: EntityTable<CommercetoolsProject, "id">;
  PINS: EntityTable<MapPinDB, "id">;
  SETTINGS: EntityTable<SettingsDB, "id">;
};

db.version(version).stores({
  LOCATIONS: "id,name,active,order",
  SETTINGS: "++id,lastProjectUpdate,lastPropertyTypeUpdate,lastLocationsUpdate,lastPinUpdate",
  PINS: "id,*categories,name,active,order",
  PROJECTS:
    "++pid,slug,id,name,*bathrooms,*bedrooms,deliveryDate,inventoryAvailable,isFurnished,*propertyType,sellable,status,*unitViews,*brands,*offers,*lifeStyle,*features,*others,serverSorting,*category",
  PROPERTY_TYPE:
    "++pid,id, slug, projectSlug, name,*bathrooms,*bedrooms,deliveryDate,inventoryAvailable,isFurnished,launchDate,*propertyType,sellable,status,*unitViews,*brands,*offers,*lifeStyle,*features,*others,serverSorting,*category",
});
